<template>
  <div class="gameBox">
    <!-- <nav-bar :title="$t('游戏')" /> -->
    <div class="txt">
      {{ $t('矿机板块建设中') }}~
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    created() {
      
    },
    methods: {
      
    },
  }
</script>

<style lang="less" scoped>
  .gameBox {
    width: 100%;
    min-height: 100vh;
    background-color: #446D7A;
    padding: 0 0 130px;
    .txt {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #fff;
      font-size: 20px;
      padding: 20px;
    }
  }
</style>
